export const getStrSeparatedByUpperCase = (key: string) =>
  key
    .split(/(?=[A-Z])/g)
    .join('-')
    .toLowerCase()
